<template>
  <v-card class="mx-auto mt-8">
    <v-card flat :max-width="maxWidth" :style="`border: 1px solid ${color};`">
      <v-card-text>
        <div class="text-center text-md-h5 text-sm-h6 text-h7 font-weight-medium">{{ $t(title) }}</div>
        <div class="text-center text-md-h7 text-sm-h7 text-h7">
          {{ $t(subtitle) }}
        </div>
      </v-card-text>
      <v-row align="center" justify="center">
        <v-img :src="src" max-width="100px" />
      </v-row>
      <v-card-text class="text-center text-md-h7 text-sm-h7 text-h7">
        {{ $t("components.thg.ThgPriceOverview.atLeast") }}
        <div
          class="text-center text-md-h5 text-sm-h6 text-h6 font-weight-black"
          :style="`color:${partnerColorDarkmode}`"
        >
          {{ price }}
        </div>
        {{ $t("components.thg.ThgPriceOverview.perVehicle") }}
      </v-card-text>
    </v-card>
  </v-card>
</template>

<script lang="ts">
import { getDefaultPartnerColor } from "@/lib/getDefaultPartnerColor";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class ThgPriceCard extends Vue {
  @Prop({ default: 800 })
  maxWidth!: number;

  @Prop()
  title!: string;

  @Prop()
  subtitle!: string;

  @Prop()
  src!: string;

  @Prop()
  price!: string;

  get color() {
    return getDefaultPartnerColor();
  }

  get partnerColorDarkmode() {
    return this.$vuetify.theme.dark ? "white" : this.color;
  }
}
</script>
